<template>
<div>
  <Nav></Nav>
    <div class="my-home container-fluid">
      <div class="row">
        <div id="search" class="col-sm-2 border-right fill" :key=this.$root.store.indexReloader>
          <LWords 
            v-if="this.$root.store.selIndex.val === 'words'"></LWords>
          <LFunctors v-else></LFunctors>
        </div>
        <div class="col-sm-10">
          <p class="text-danger" v-if="this.$root.store.api_error != null">
              {{ this.$root.store.api_error }}
          </p>
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "./Nav"
import LWords from "./LWords"
import LFunctors from "./LFunctors"
import MainDispl from "./MainDispl"

export default {
  name: 'Home',
  components: {
    Nav: Nav,
    LWords: LWords,
    LFunctors: LFunctors,
    MainDispl: MainDispl,
  },
}
</script>

<style scoped>
.my-home {
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue